import React , {useState} from 'react';
import "../styles/App.scss";
import "../styles/PagesStyles.scss";
import {Paper, Button} from '@mui/material';
import MyModal from '../components/MyModal';

export default function MySlideshow(props){
    const [open, setOpen] =useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return(
        <Paper>
            {/*  */}
            <Button onClick={handleClickOpen}>
                <img className={props.imageClass} src={props.item.img} alt={props.item.description}/>
            </Button>

            <MyModal
                open={open}
                onClose={handleClose}
                img = {props.item.img}
                description = {props.item.description}
            />
        </Paper>
    )
}